import { useEffect, useState } from "react";

export function useLazyMount(isOpen: boolean): boolean {
  const [wasOpened, setWasOpened] = useState(isOpen);

  useEffect(
    function markAsOpenedOnce() {
      if (isOpen) setWasOpened(true);
    },
    [isOpen],
  );

  return wasOpened;
}
